import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const Container = styled.div`
  width: 100%;

  .swiper {
    position: relative;
    padding: 0 ${themeGet('space.7')}px ${themeGet('space.13')}px;
  }

  .swiper-pagination-bullet-active {
    background-color: ${themeGet('colors.primary.main')};
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    height: unset;
    flex-grow: 1;
  }
`
export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-inline: 100px;
  background-color: ${themeGet('colors.background.screenAlt')};
  z-index: 1;
  pointer-events: none;

  mask-image: linear-gradient(
    90deg,
    rgba(0, 0, 0, 1) 0%,
    transparent 40%,
    transparent 60%,
    rgba(0, 0, 0, 1) 99%
  );
`
